export interface StreamProgress {
  profileReady: boolean;
  axesReady: boolean;
}

export interface ProcessingViewProps {
  candidateName?: string;
  streamProgress: StreamProgress;
  resultReady: boolean;
  onShowResults: () => void;
  onCancel: () => void;
}

interface Beat {
  id: keyof StreamProgress;
  label: string;
  description: string;
}

const BEATS: Beat[] = [
  {
    id: "profileReady",
    label: "Perfil extraído",
    description: "LinkedIn / PDF / texto livre processados.",
  },
  {
    id: "axesReady",
    label: "Competências avaliadas",
    description: "O perfil do candidato foi comparado com a rubrica de cada competência.",
  },
];

export function ProcessingView(props: ProcessingViewProps) {
  return (
    <div className="ci-stripe ci-stripe-page">
      <div className="ci-narrow fade-up" style={{ width: "100%" }}>
        <div className="card">
          <div className="card-head">
            <div className="card-head-left">
              <p
                className="eyebrow"
                style={{
                  font: "600 11px/1.4 'Inter', sans-serif",
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: "var(--r-ink-muted)",
                  margin: "0 0 4px",
                }}
              >
                Em curso
              </p>
              <h2>{props.candidateName ?? "Avaliando candidato"}</h2>
              <div className="sub">
                Analisamos o histórico profissional e avaliamos cada competência do modelo.
              </div>
            </div>
          </div>

          <div className="card-body padded">
            <ol
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              {BEATS.map((beat) => {
                const done = props.streamProgress[beat.id];
                return (
                  <li
                    key={beat.id}
                    data-testid={`labs-la-beat-${beat.id}`}
                    style={{
                      display: "flex",
                      gap: 12,
                      padding: "12px 16px",
                      borderRadius: 8,
                      background: done ? "rgba(34, 139, 34, 0.06)" : "transparent",
                      border: "1px solid",
                      borderColor: done ? "var(--r-forest, #228B22)" : "var(--r-line, #e0e0d8)",
                      transition: "all 200ms ease-out",
                    }}
                  >
                    <span
                      aria-hidden
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: done ? "var(--r-forest, #228B22)" : "var(--r-ink-muted, #999)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginTop: 2,
                        background: done ? "var(--r-forest, #228B22)" : "transparent",
                      }}
                    >
                      {done && (
                        <svg width="12" height="12" viewBox="0 0 12 12" focusable="false">
                          <title>concluído</title>
                          <path
                            d="M2.5 6L5 8.5L9.5 3.5"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </span>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          color: "var(--r-ink)",
                          lineHeight: 1.4,
                        }}
                      >
                        {beat.label}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: "var(--r-ink-muted)",
                          lineHeight: 1.5,
                          marginTop: 2,
                        }}
                      >
                        {beat.description}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>

            <div
              style={{
                marginTop: 24,
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <button
                type="button"
                className="btn ghost"
                onClick={props.onCancel}
                data-testid="labs-la-cancel"
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn primary"
                onClick={props.onShowResults}
                disabled={!props.resultReady}
                data-testid="labs-la-show-results"
              >
                {props.resultReady ? "Ver resultado" : "Aguardando…"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
